import { AccessControl } from '../api';

export type ThingType = AccessControl.ThingType;
export const ThingType = AccessControl.ThingType;
